import React from "react";
import styles from "./styles.scss";
import { Report } from "./report";

function Loader() {
  return (
    <ul className={styles.reportsList}>
      <li className={styles.report}>
        <Report />
      </li>
      <li className={styles.report}>
        <Report />
      </li>
      <li className={styles.report}>
        <Report />
      </li>
      <li className={styles.report}>
        <Report />
      </li>
    </ul>
  );
}

export { Loader };
